// Sticky CTA mobile · botão "Começar com 7 dias de garantia" fixo no bottom em <md.
// Aparece após scroll do hero (uso de IntersectionObserver via 'use client').

'use client';

import { useEffect, useState } from 'react';

import { initiateCheckout } from '@/lib/tracking/dispatch';

export function StickyMobileCta() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    function onScroll() {
      setShow(window.scrollY > 600);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      data-floating
      className={`pointer-events-none fixed inset-x-0 bottom-0 z-30 px-4 pb-4 transition-all duration-300 md:hidden ${
        show ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'
      }`}
    >
      <a
        href="/precos"
        onClick={() => {
          initiateCheckout({
            content_name: 'sticky-mobile-trial',
            content_category: 'landing-cta',
          });
        }}
        className={`bg-trakd-fill text-on-brand shadow-trakd-glow-strong pointer-events-auto flex min-h-[52px] items-center justify-center rounded-full px-6 py-3 text-base font-medium`}
      >
        Começar com 7 dias de garantia →
      </a>
    </div>
  );
}
